import { IParameterProperty } from '../../../../../../types/IParameter';
import Parameter from '../../Parameter';

interface IOption {
  active: boolean;
  assignable: boolean;
  id: string;
  name: string;
  readOnly: boolean;
  sinceLastOpen: boolean;
  text: string;
  value: string;
}

export interface IMulticheckboxParameterProperty extends IParameterProperty {
  options: IOption[];
}

class Multicheckbox extends Parameter {
  public options: IOption[];

  constructor(parameter: IMulticheckboxParameterProperty) {
    super({
      ...parameter,
      value: parameter.options.filter(option => option.active).map(option => option.id),
    });

    this.options = parameter.options;
  }

  public getSelected() {
    return this.options.filter(option => this.value.indexOf(option.id) > -1);
  }

  public getPayloadValue(): any {
    const currentValues = (this.value as string[]).map((value: string, i) => ({
      name: `${this.name}[value][${i}]`,
      value,
    }));
    const originals = (this.originalValue as string[]).map((value: string, i) => ({
      name: `${this.name}[original][${i}]`,
      value,
    }));
    return currentValues.concat(originals);
  }

  public valueChanged(): boolean {
    return super.valueChanged() === true && this.options.every(item => item.active === false) === false;
  }

  public reset(): void {
    super.reset();

    this.options = this.options.map(option => ({
      ...option,
      active: this.value.includes(option.id),
    }));
  }
}

export default Multicheckbox;
